import { FlightCard } from '../FlightCard/FlightCard';

import type { FlightCardProps } from '../FlightCard/FlightCard';

import STYLES from './FlightCardList.module.scss';

type Props = {
  cards: FlightCardProps[];
  onCardHover?: (id: string) => void;
  onCardHoverLeave?: () => void;
};

export const FlightCardList = ({ cards, onCardHover, onCardHoverLeave }: Props) => {
  if (cards.length === 0) {
    return null;
  }

  return (
    <ul className={STYLES.list} data-testid="flight-card-list">
      {cards.map((card, index) => {
        const { destinationAirportCode } = card;
        return (
          <li key={card.exploreUrl}>
            <FlightCard
              {...card}
              area="list"
              position={index + 1}
              onMouseEnter={
                onCardHover && destinationAirportCode
                  ? () => onCardHover(destinationAirportCode)
                  : undefined
              }
              onMouseLeave={onCardHoverLeave}
            />
          </li>
        );
      })}
    </ul>
  );
};
